// extracted by mini-css-extract-plugin
export default {"root":"FULtUy","text":"iTUETV"};